import { Error } from '../Error'
import { Width } from '../Width'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

import type { TextField } from '@payloadcms/plugin-form-builder/types'
import type {
  FieldErrorsImpl,
  FieldValues,
  RegisterOptions,
  UseFormRegister,
} from 'react-hook-form'

type TextProps = TextField & {
  errors: Partial<FieldErrorsImpl>
  register: UseFormRegister<FieldValues>
  placeholder?: string
  validation?: RegisterOptions<FieldValues>
  type?: string
  className?: string
  disabled?: boolean
}

export const Text: React.FC<TextProps> = ({
  name,
  defaultValue,
  errors,
  label,
  register,
  required,
  placeholder,
  validation,
  type = 'text',
  className,
  disabled,
}) => {
  const validationRules: RegisterOptions<FieldValues> = {
    required: required ? (required === true ? 'This field is required' : required) : false,
    maxLength: { value: 200, message: 'Maximum length is 200 characters' },
    ...validation,
  }

  return (
    <Width>
      <Label htmlFor={name}>
        {label}

        {required && (
          <span className="required">
            * <span className="sr-only">(required)</span>
          </span>
        )}
      </Label>
      <Input
        defaultValue={defaultValue}
        id={name}
        type={type}
        className={className}
        {...register(name, validationRules)}
        placeholder={placeholder}
        disabled={disabled}
      />
      {errors[name] && <Error name={name} />}
    </Width>
  )
}
